import { PatientGuarantor } from "pwapi";

import FlatResourceLine from "./FlatResourceLine";

type GuarantorLineProps = {
  guarantor: PatientGuarantor;
  onEditGuarantor?: Function;
};

const GuarantorLine = ({ guarantor, onEditGuarantor }: GuarantorLineProps) => {
  return (
    <FlatResourceLine resource={guarantor} onEdit={onEditGuarantor}>
      <span>
        {guarantor.last_name}, {guarantor.first_name} {guarantor.middle_initial}
        {guarantor.address && (
          <>
            <br />
            {guarantor.address.street}
            {guarantor.address.street2 && <>, {guarantor.address.street2}</>}
            <br />
            {guarantor.address.city}, {guarantor.address.state}{" "}
            {guarantor.address.zipcode}
          </>
        )}
      </span>
    </FlatResourceLine>
  );
};

export default GuarantorLine;
